module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h2', [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1em",
      "line-height": "1.5",
      "text-indent": "1.5em"
    }
  }, [_vm._v("“I’ll do what I God damn please,” Dunne said.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray waited.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m not going to be turned into a robot.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne’s anger rose as his fear dwindled.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“One thing you psychoanalysts forget is that people are individuals. You can’t cut ’em all down to one size. I was better off before I started with you. Conform—that’s all you people think about. Maybe I’m not the only one out of step. Hell, why don’t you tell Farragut to conform? He knows Mary’s my wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray waited.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I go to bed with her. I … chase around a lot, sure. But afterwards—” Dunne clenched his fists. “Afterwards—oh, God damn!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He glared at the psychoanalyst.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It’s what you want me to do. But then you’ll—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He was breathing hard. Suddenly he stood up and took a step toward the desk. Dunne was a big man, and his physical presence, coupled with the violence of his anger, made the office seem small and constricted. Gray forced himself to wait. He knew that he faced a genuine danger.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He was overwhelmingly conscious of the big, angry man on the other side of the desk.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You son of a bitch,” Dunne said breathlessly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray waited.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Look at me!” Dunne cried, in a hoarse, shaking voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray turned his head and met Dunne’s stare. The man’s eyes were glazed. His pupils were dilated, and his face had a purplish, swollen look.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Instantly Dunne knew that he had made a mistake. For one of the oldest terrors of childhood is the fear that one’s mind may be read, and that it may be done through the eyes. Gray put himself in Dunne’s place. He became Dunne, feeling with the man’s emotions. And—as Dunne—he knew then that probing eyes were striking past the innermost defenses of the mind, finding the secrets known consciously not even to Dunne himself….")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The purple flush died away; Dunne’s face turned chalk-gray. But only for an instant. Fear and pain combined like a flash of violent lightning. Dunne made a snarling noise in his throat. His hand thrust forward.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His strong fingers closed on the bronze satyr on Gray’s desk. Even though it was hollow, it could crush a man’s skull, the analyst thought.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For a moment Dunne stood there, bent forward, struggling. And the struggle was internal. It showed in his rasping breath, his clenched teeth, the taut tendons of the hand that gripped the statuette.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray fought with himself too. His mind told him that this was the turning point for Howard Dunne. But his emotions told him that he faced death.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It happened in a split second. With a violent effort, Gray controlled his emotions and turned them in a different direction. Again, he became Howard Dunne. He felt with Dunne’s emotions, and, as he did, he sensed what was the right thing to do. He knew, intuitively but certainly, what Dunne, pushed almost over into the abyss, needed to save himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray said calmly, “It’s all right, son.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne stood motionless. But something happened to him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His hand began to relax its grip on the bronze satyr. It tightened, and then suddenly let go completely. Dunne covered his face with his hands and began to cry, deep, gasping, painful sobs that shook his whole body. He turned, found his chair, and collapsed into it. He bent forward, covering his face, and shook helplessly in the grip of the emotional storm.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray surreptitiously wiped the sweat from his face.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At last, brokenly, Dunne began to talk.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t want to,” he said thickly. “I can’t help it. I have to … Farragut— I’m as good a man as he is. I’ve got to prove it. I’ve got to … but afterwards I hate her. That’s what I’m afraid of.” He drew a deep breath.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t know. If Mary loves me, why does she go on seeing Farragut? I’m never sure. I never was sure about my mother. Sometimes she loved me. But—she—hated me too. It was—It’s like that with Mary. She and Father—, Farragut—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He stopped short.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Father?” he said. “I didn’t hate my mother. I loved her, except when she pushed me away.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray’s silent presence gave reassurance. Dunne went on.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“After Dad went to Spain, I was afraid he’d find out about the letter. The one my mother gave me to deliver to him. I was afraid he’d find out I—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray waited. Finally Dunne said,")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I knew when he came back he’d find out. So—I tried to figure out how to stop that happening. If my mother died—or if Dad died. And he was killed in Spain. So he never found out what I did with the letter. I—what did I do? I hid it somewhere. There was a key … no, the letter—that was the key. But … oh, God!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He slumped forward, exhausted, breathing deeply.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He said, “Every time I went on a combat mission, I think I really was hoping I’d be killed. I … tried to make them kamikaze missions. Death is … the door. For my key.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then there was silence for a long time. At last Dunne lifted his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I guess I’ve kept you overtime,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Well—I feel better.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Good,” Gray said. “You’ve come a long way during this hour. People don’t allow themselves to recognize their conflicts unless they feel strong enough to deal with them. I think you feel able to face more of your problems now. But it’s not easy to talk about them to another person. Especially when they’re such important problems. That’s why talking about them brings strong feelings to the surface.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne smiled faintly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Thanks,” he said. “Next—next time will be better.”")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop"
  }, [_vm._v("Next time Dunne said, “Sam’s going to move in with us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His face was mask-like. His eyes looked small.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray said, “Tell me about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I can’t stand this,” Dunne said. “The three of us, locked in together. I can’t face it. We had a hell of an argument. But—I got scared. I can’t stop him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“How did it happen?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Mary found out about the money,” Dunne said. “She was upset … Anyway, she went out. I kept thinking about that bastard Farragut. I didn’t know where she’d gone. I phoned Sam, but she wasn’t there. So I drove over to Farragut’s apartment. He didn’t want to let me in.” Dunne drew a long breath. “I got in anyway. It only took one punch.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Well, she wasn’t there,” Dunne said, rather flatly. “When I got home, there she was. She’d just gone down the street to a restaurant for dinner. Then she’d come home, and Sam was on the steps waiting. He was there, too, when I got back. Both of them. We had a hell of a row. I didn’t intend to, but I told ’em I’d knocked Farragut cold, and—Jesus, I was mad. It felt good. That was funny. I felt—almost on the edge of—of being safe, somehow.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Safe from what?” Gray asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The pressure,” Dunne said. “I could fight back. But it wasn’t any good…. There was the money, you see. And I was yelling at both of them … telling Mary to get a divorce and marry Farragut if she felt like it. Sam said analysis was making me worse. That I belong in a sanitarium. He wants me to stop seeing you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray waited.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He kept hammering at that,” Dunne said. “He said I should be in a sanitarium. I told him to go to hell, that he couldn’t have me locked up if he tried his damnedest, and that you’d—you’d back me up on that. Then he wanted me to change to another analyst. He kept "), _c('i', [_vm._v("pushing")]), _vm._v(". It got harder and harder to—stand up to him. I wanted to hit him. But I couldn’t. And finally he said Mary wasn’t safe with me, and he was going to move in with us for a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There was a long pause. Gray said, “What happened then?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“We were both shouting,” Dunne said. “All of a sudden I … got scared. I went in my bedroom and locked the door. That—was all.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What scared you?” Gray asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t know. I was afraid I’d—that he’d—I don’t know. I felt—” Dunne rubbed his left arm. “Sam grabbed my arm. That was when I got scared. My father used to do that a lot. But it was a friendly grip. I mean, it didn’t hurt. Only last night, when Sam did it, I felt—I had to tell him something.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t know,” Dunne said, his face colorless. “It was like a key turning. I—I—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You felt you’d have to tell him something.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“How did you feel about that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I told you. I was scared to death.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“But part of you wanted to tell him?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne moistened his lips.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Part of me? I—I guess so. But why?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What would happen if you told him?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“They didn’t kill me,” Dunne said suddenly. “The enemy planes, I mean. That was why I felt disappointed when I got back safe from combat. They didn’t … give me—” He shut his eyes. “That letter. I remember now. The one I was supposed to give to my father. I did give it to him. I gave it to him, but he mustn’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Why mustn’t he?” Gray asked softly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The door mustn’t be opened. It’s the wrong door.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What’s the right door?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s wrong too,” Dunne said, moving restlessly in the chair. “"), _c('i', [_vm._v("Sam mustn’t move in!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There was a long pause. Gray said, “What are you thinking now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Punishment,” Dunne said. “That’ll make it all right, won’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Make what all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t know,” Dunne said. “That’s why I can’t confess. I don’t remember where I hid the letter. If I did, I could confess and take my punishment and it would be—ended.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“So you confess to other things instead.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne looked startled.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“When you slept with your C.O.’s mistress, during the war, he found out about it and punished you, didn’t he?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I see,” he said slowly. “Yes, it’s been like that for a long time. You mean I wanted to get into trouble?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Well, the times I got off easy—I felt disappointed. But why should I want to be punished?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Why should you want to confess?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m two men,” Dunne said softly. “One of me wants to confess. The other doesn’t. I need two people. One to confess to. The other to….”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“To what?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“To punish me,” Dunne said. “But he won’t. Not unless I confess to "), _c('i', [_vm._v("him")]), _vm._v(". And … I can’t. I’ve got to do it without doing it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“How?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He mustn’t know,” Dunne said. He was silent for a long time. Then he said, in a new tone, “Of course the real trouble’s the money. I’ll have to stop seeing you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Didn’t I tell you? Mary found out about the money.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ve been wondering about that,” Gray said. “You didn’t go into any details.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Well, I had about fifteen thousand invested in securities. I haven’t—I had to sell out. And Mary didn’t know till yesterday.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“How did she find out?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“She saw a list my broker sent me. I brought it home by mistake. And I left it right on top of the TV, where—” He stopped abruptly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Where she’d be sure to see it?” Gray asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne nodded slowly. “But it doesn’t matter. I’ll have to stop seeing you. I can’t afford sixty dollars a week.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Could you afford them before now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No,” Dunne said. “I—I was mixed up about it. Somehow, I felt I could pay for therapy out of those securities. In a way, I knew I didn’t have them any more, but … hell, I guess I felt that when you found out, you’d kick me out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“When you confessed, I’d punish you. Is that it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne hesitated and then nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I could get the money from Sam,” he said. “But then I’d have to let him move in with us. Oh, hell, do you know where the money went? Eleanor got it. I told you I was sleeping with her. She had to have money for gambling.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Is that why you gave her the money?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne said, “I had to, or she’d have told Sam about us. That’s one reason I’ve felt worried. It’s a good motive for murder, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray waited.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne’s tension increased.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He said quickly, “I didn’t kill her. I’d tell you if I had. That’s not the trouble. It’s—Sam moving in. And I can’t stop him. I get too scared, somehow.” He drew a deep breath. “But I can’t go on seeing you. I can’t pay this much.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray said, “Don’t worry about that. My fees are flexible. Figure out what you can pay without hardship—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’d rather stop seeing you until I can afford it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Why?” Gray asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Well—I should have told you before how things stood.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Why didn’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne glanced uneasily toward the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t know. I couldn’t. I—I was tricking you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Did it work?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne made a slight, sudden movement.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray said, “You’re doing your best to get me to send you away, aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s not it. You….”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The psychoanalyst said, “The financial side of it can be worked out. I think the important point, right now, is how you feel about therapy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I need it,” Dunne said. “But—only with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“All right,” Gray said. “Then we’ll go ahead just as we have been. But what about Sam’s moving in with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne shook his head slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m afraid of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Can you stop him?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m not sure. That—panic—is what I’m afraid of.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes. Well, if Sam moves in, do you have to stay?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This was a crucial question. The seconds dragged on. And the worry in Gray’s mind grew stronger.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne didn’t answer.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At last Gray said, “This is a tough situation for you. You remember I said once that the relatives of a patient sometimes are uncooperative?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Uncooperative?” Dunne laughed harshly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray came to a decision.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Here’s what I suggest,” he said. “I’d like to talk to your doctor. If he can make it clear to Sam and Mary that it’s unwise for Sam to move in with you, that should help. If not, I’d like your permission to see your wife again, and your brother-in-law.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Would you?” Dunne asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne glanced at his watch and stood up. So did Gray.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Suddenly Gray said, “I think it might be a good idea if I saw you more frequently for a bit. What do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes,” Dunne said. “I think—that would help.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“All right. Could you make it tomorrow? At five?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ll be here,” Dunne said. “Thanks.” He went out, looking relieved.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray went quickly to the phone and dialed Dunne’s physician.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Well, I don’t know,” Dr. Felix Branson’s thin voice said presently over the wire. “Pope isn’t one of my patients, so I don’t pull much weight with him. But I’d be glad to talk to Mrs. Dunne. What is it, one of these family interference deals?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Pope wants to move in with the Dunnes,” Gray said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“My mother-in-law’s been trying to move in with us for years,” Dr. Branson said. “It’s easy to handle these things. All it takes is a will of iron.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Exactly.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I know you can’t go into details. But how is Howard doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He’s improving,” Gray said. “That’s the trouble. He’s working out more of his conflicts externally now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“So Pope wants to move in, eh? Aren’t there any alternatives?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Not as many as I’d like. If Pope won’t string along, I’m going to try to get Dunne to agree to a consultation. You know Emery?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The psychiatrist? Yes. He’s one of the best.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And I hope you’d be with us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Anything I can do,” Dr. Bronson said. “You really think it’s necessary?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’d say it depends on what Pope does,” Gray said. “He could tip the balance.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ll call Mrs. Dunne,” Dr. Bronson said. “Then I can tell if it’s any good to phone Pope. I’ll call you back.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray had to be satisfied. He cradled the phone, leaned back in his chair, and stared at the bronze satyr on his desk. Then he reached forward and picked it up. It was not as heavy as it looked, but it was sufficiently weighty to be dangerous. Gray hefted the statuette. The outer door opened. Gray replaced the satyr and stood up, ready for his next patient.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Just after she left, the telephone rang again. It was Bronson.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ve talked to both of them,” the physician said. “Mrs. Dunne’s all right. She wants a quick answer, like all of ’em. I told her it was like relatives yanking a surgery patient off the table in the middle of an operation, and then complaining to the surgeon that he was bleeding. She’ll play along now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You’re pretty sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Quite sure,” Bronson said. “But I’m not so sure about Pope. I phoned him too. I think you ought to see him, if it’s possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I already did,” Gray said. “If he hadn’t promised that he’d cooperate, I don’t think I’d have accepted Dunne as a patient.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I know,” Bronson said. “We’ll just have to do what we can. In your shoes, I’d have done the same thing. How could you tell Pope would double-cross you? Better see him. He’s impulsive, but he’s not completely unreasonable.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ll see him,” Gray said grimly.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04cb8fd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/15_chapter11.vue
// module id = 105
// module chunks = 0